'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
var reactResponsiveModal_esm = require('../../../node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js');
require('./style.scss.js');
var index = require('../../../node_modules/classnames/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ModalResponsive = function (props) {
    var isOpen = props.isOpen, asBottomSheet = props.asBottomSheet, closeBackdropClick = props.closeBackdropClick, showClose = props.showClose, center = props.center, title = props.title, children = props.children, size = props.size, onClose = props.onClose;
    return (React__default['default'].createElement(reactResponsiveModal_esm['default'], { center: center, open: isOpen, classNames: {
            root: 'root',
            modal: asBottomSheet ?
                'bottomsheet__wrapper' :
                (index['default']("modal__wrapper", "modal-" + size)),
        }, onClose: onClose, closeOnOverlayClick: closeBackdropClick, showCloseIcon: showClose, closeIcon: React__default['default'].createElement(React__default['default'].Fragment, null) },
        (title || showClose) && (React__default['default'].createElement("div", { className: "modal__wrapper--header" },
            React__default['default'].createElement("h3", null, title),
            showClose && React__default['default'].createElement("div", { className: 'modal-close', onClick: onClose }, "Tutup"))),
        React__default['default'].createElement("div", { className: "modal__wrapper--child" }, children)));
};

module.exports = ModalResponsive;
//# sourceMappingURL=ResponsiveModal.js.map
